import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  call(event) {
    const orgId = event.currentTarget.dataset.organizationId
    if (!orgId || !window.ahoy) return

    window.ahoy.track("organization_call_tapped", { org_id: Number(orgId) })
  }
}
